export default {
  'deployment.title': '部署运维控制台',
  'deployment.subtitle':
    '从代码仓库到 GitLab CI、Kubernetes 运行态和日志的一站式管理',
  'deployment.status.success': '成功',
  'deployment.status.failed': '失败',
  'deployment.status.canceled': '已取消',
  'deployment.status.running': '构建中',
  'deployment.status.pending': '等待中',
  'deployment.status.created': '已创建',
  'deployment.status.skipped': '已跳过',
  'deployment.status.notDeployed': '未部署',
  'deployment.message.loadFailed': '部署运维数据加载失败',
  'deployment.message.saved': '部署配置已保存',
  'deployment.message.saveFailed': '部署配置保存失败',
  'deployment.message.pipelineStarted': 'GitLab CI 流水线已启动',
  'deployment.message.deployFailed': '构建部署启动失败',
  'deployment.message.deleted': '部署配置已删除',
  'deployment.message.deleteFailed': '部署配置删除失败',
  'deployment.message.noAccessAddress': '当前服务未配置访问地址',
  'deployment.message.addressCopied': '访问地址已复制',
  'deployment.message.copyFailed': '访问地址复制失败',
  'deployment.message.logDownloaded': '日志下载成功',
  'deployment.message.logDownloadFailed': '日志下载失败',
  'deployment.deploy.confirmTitle': '确认构建并部署',
  'deployment.deploy.confirmDescription':
    '系统将提交标准 GitLab CI 与 Helm values 到所选分支，并立即触发流水线。',
  'deployment.action.deploy': '构建并部署',
  'deployment.action.quickDeploy': '部署',
  'deployment.action.quickLog': '日志',
  'deployment.action.more': '更多',
  'deployment.action.cancel': '取消',
  'deployment.action.newConfiguration': '新建部署配置',
  'deployment.action.edit': '编辑配置',
  'deployment.action.delete': '删除',
  'deployment.action.save': '保存配置',
  'deployment.action.refresh': '刷新',
  'deployment.action.viewLog': '查看日志',
  'deployment.action.addVariable': '添加环境变量',
  'deployment.action.deleteVariable': '删除环境变量',
  'deployment.action.addRoute': '添加依赖服务路由',
  'deployment.action.deleteRoute': '删除依赖服务路由',
  'deployment.action.backToList': '全部部署',
  'deployment.delete.confirm': '确定删除此部署配置？',
  'deployment.common.status': '状态',
  'deployment.common.branch': '分支',
  'deployment.common.createdAt': '创建时间',
  'deployment.common.action': '操作',
  'deployment.list.title': '全部部署',
  'deployment.list.description':
    '集中管理当前项目中所有服务的构建、发布与运行状态',
  'deployment.list.searchPlaceholder': '搜索服务名、代码仓库或域名',
  'deployment.list.total': '部署配置',
  'deployment.list.deployed': '已部署',
  'deployment.list.attention': '需要关注',
  'deployment.list.service': '服务',
  'deployment.list.endpoint': '访问地址',
  'deployment.list.lastDeployedAt': '最近部署',
  'deployment.list.noMatch': '没有匹配的部署配置',
  'deployment.list.unit': '个服务',
  'deployment.list.totalPrefix': '共',
  'deployment.list.totalSuffix': '条',
  'deployment.filter.label': '筛选部署',
  'deployment.filter.all': '全部部署',
  'deployment.filter.deployed': '已部署',
  'deployment.filter.notDeployed': '未部署',
  'deployment.filter.attention': '需要关注',
  'deployment.more.history': '查看部署历史',
  'deployment.more.logs': '查看日志',
  'deployment.more.downloadLog': '下载日志',
  'deployment.more.configuration': '查看配置',
  'deployment.more.copyAddress': '复制访问地址',
  'deployment.more.redeploy': '重新部署',
  'deployment.more.delete': '删除部署配置',
  'deployment.empty.title': '从一个标准部署配置开始',
  'deployment.empty.description':
    '选择代码仓库，填写服务、域名与资源规格，即可生成标准 CI 配置并完成构建部署。',
  'deployment.tab.overview': '运行概览',
  'deployment.tab.configuration': '部署声明',
  'deployment.overview.releaseStatus': '发布状态',
  'deployment.overview.repository': '代码仓库',
  'deployment.overview.endpoint': '服务入口',
  'deployment.overview.health': '实例健康度',
  'deployment.overview.latestPipelines': '最近流水线',
  'deployment.overview.releaseContract': '发布契约',
  'deployment.overview.podStatus': 'Pod 运行情况',
  'deployment.overview.podNode': '所在节点',
  'deployment.overview.podStartedAt': '启动时间',
  'deployment.pipeline.id': '流水线',
  'deployment.pipeline.commit': '提交',
  'deployment.pipeline.noJobs': '选择流水线查看阶段任务',
  'deployment.pipeline.jobs': '流水线阶段',
  'deployment.runtime.pod': 'Pod',
  'deployment.runtime.podIp': 'Pod IP',
  'deployment.runtime.pods': '运行实例与日志',
  'deployment.runtime.ready': '就绪',
  'deployment.runtime.restarts': '重启',
  'deployment.runtime.usage': '实时用量',
  'deployment.runtime.replicas': '副本状态',
  'deployment.runtime.desired': '期望',
  'deployment.runtime.unavailable': '不可用',
  'deployment.runtime.resources': '资源配置',
  'deployment.runtime.notFound': '当前配置尚未在 Kubernetes 中创建 Deployment',
  'deployment.runtime.metricsUnavailable':
    '监控指标暂不可用（集群可能未安装 metrics-server 或权限不足），无法显示 CPU/内存实时用量',
  'deployment.log.noRunningPod': '当前没有可读取日志的运行实例',
  'deployment.form.helper':
    '保存只记录部署声明；点击“构建并部署”后才会提交到 GitLab 并触发 CI。',
  'deployment.form.tab.basic': '基础配置',
  'deployment.form.tab.runtime': '资源与健康',
  'deployment.form.tab.variables': '环境变量',
  'deployment.form.source': '代码来源',
  'deployment.form.sourceHint': '选择构建仓库及部署分支',
  'deployment.form.service': '服务配置',
  'deployment.form.serviceHint': '定义 Kubernetes 工作负载的基础参数',
  'deployment.form.repository': '代码仓库',
  'deployment.form.repositoryPlaceholder': '选择已关联 GitLab 的代码仓库',
  'deployment.form.branch': '部署分支',
  'deployment.form.appName': '服务名',
  'deployment.form.namespace': '命名空间',
  'deployment.form.replicas': '副本数',
  'deployment.form.targetPort': '容器端口',
  'deployment.form.serviceAccountName': 'ServiceAccount（可选）',
  'deployment.form.serviceAccountNameHint':
    '仅需访问 K8s API 的应用需要填写，需提前创建好对应 ServiceAccount 及 RBAC；留空则使用命名空间 default',
  'deployment.form.ingress': '公网访问',
  'deployment.form.ingressHint': '启用后通过域名访问服务',
  'deployment.form.domain': '域名',
  'deployment.form.domainPrefixHint': '仅填写域名前缀，固定后缀由系统自动拼接',
  'deployment.form.dependencyRoutes': '依赖服务路由',
  'deployment.form.dependencyRoutesHint':
    '将同一域名下的指定路径转发到集群内服务，例如 /bff → zy-example-server',
  'deployment.form.routePath': 'Ingress 路径',
  'deployment.form.routeServiceName': '目标服务名',
  'deployment.form.routeServicePlaceholder': '选择已有部署服务',
  'deployment.form.routeServiceEmpty': '当前项目暂无已有部署服务',
  'deployment.form.resources': '资源规格',
  'deployment.form.requests': '资源请求',
  'deployment.form.requestsHint': '调度时预留的最低资源',
  'deployment.form.limits': '资源上限',
  'deployment.form.limitsHint': '单个实例可使用的最大资源',
  'deployment.form.cpu': 'CPU',
  'deployment.form.memory': '内存',
  'deployment.form.cpuRequest': 'CPU 请求',
  'deployment.form.cpuLimit': 'CPU 上限',
  'deployment.form.memoryRequest': '内存请求',
  'deployment.form.memoryLimit': '内存上限',
  'deployment.form.liveness': '存活探针',
  'deployment.form.readiness': '就绪探针',
  'deployment.form.probeHint': '用于判断实例是否健康并可接收流量',
  'deployment.form.healthPath': '检查路径',
  'deployment.form.initialDelay': '初始延迟（秒）',
  'deployment.form.period': '周期（秒）',
  'deployment.form.sharedEnv': '共享环境变量',
  'deployment.form.sharedEnvHint':
    '挂载 zhiyue 平台的共享环境变量 Secret（zhiyue-shared-env）；关闭后应用只使用下方自定义变量',
  'deployment.form.environmentVariables': '环境变量',
  'deployment.form.variablesHint': '敏感值保存后不会在列表中直接展示',
  'deployment.form.variableKey': '变量名',
  'deployment.form.variableValue': '变量值',
  'deployment.form.valuesFile': '配置文件',
  'deployment.common.enabled': '已启用',
  'deployment.common.disabled': '未启用',
  'deployment.validation.domainPrefix':
    '请输入有效的二级域名前缀，仅支持小写字母、数字和连字符，且不能以连字符开头或结尾',
  'deployment.validation.duplicateRoute': 'Ingress 路径不能重复',
  'deployment.modal.edit': '编辑部署配置',
  'deployment.modal.create': '新建部署配置',
  'deployment.pipeline.pageTitle': '流水线记录',
  'deployment.pipeline.pageSubtitle':
    '查看各服务的 GitLab CI 构建历史与阶段日志',
  'deployment.runtime.pageTitle': '运行监控',
  'deployment.runtime.pageSubtitle':
    '查看 Kubernetes 运行实例、资源用量与容器日志',
  'deployment.picker.label': '部署服务',
  'deployment.picker.placeholder': '选择部署服务',
  'deployment.picker.empty.title': '当前项目还没有部署配置',
  'deployment.picker.empty.description':
    '先在部署控制台创建部署配置并完成一次构建部署，再回到这里查看。',
  'deployment.action.goConsole': '前往部署控制台',
  'deployment.more.runtime': '查看运行监控',
  'deployment.overview.viewAllPipelines': '查看全部',
  'deployment.log.loadFailed': '日志加载失败',
  'deployment.log.downloading': '正在准备日志下载…',
  'deployment.log.latestLines': '最近 500 行',
  'deployment.log.polling': '实时刷新中',
  'deployment.log.loading': '正在加载日志…',
  'deployment.log.empty': '暂无日志',
};
